(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31],{

/***/ 1276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[author]/[profile]",
      function () {
        return __webpack_require__(552);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AlertPopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var _AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4626);
/* harmony import */ var _AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8688);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);





const AlertPopup = (param)=>{
    let { type , children , onClickClose , isOpen  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wrapper), (_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_".concat(type)], isOpen && (_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default().isOpen)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
                view: "wide",
                posRelative: true,
                largePadding: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default().content),
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (_AlertPopup_module_sass__WEBPACK_IMPORTED_MODULE_4___default().close),
                        onClick: onClickClose,
                        "aria-label": "close",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
                            name: "close"
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 8688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Box_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8774);
/* harmony import */ var _Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Box_module_sass__WEBPACK_IMPORTED_MODULE_3__);




function Box(props) {
    var _props_marginTop, _props_marginTop1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper), props.view === "half" && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default().half), props.posRelative && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default()["view-relative"]), props.largePadding && (_Box_module_sass__WEBPACK_IMPORTED_MODULE_3___default()["view-largePadding"])),
        style: {
            marginTop: "".concat((_props_marginTop = props.marginTop) !== null && _props_marginTop !== void 0 ? _props_marginTop : 0, "px"),
            marginBottom: "".concat((_props_marginTop1 = props.marginTop) !== null && _props_marginTop1 !== void 0 ? _props_marginTop1 : 0, "px")
        },
        children: props.children
    });
}


/***/ }),

/***/ 5047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ CustomUpload; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8523);
/* harmony import */ var _utils_ThumbnailContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6412);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2405);
/* harmony import */ var _CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(706);
/* harmony import */ var _CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);










const CustomUpload = (param)=>{
    let { maxFiles =5 , iconDecoration , areaDescription , footerDescription , ...props } = param;
    const { getRootProps , getInputProps , isDragAccept , isDragReject , isFocused , acceptedFiles , open , fileRejections  } = (0,react_dropzone__WEBPACK_IMPORTED_MODULE_7__/* .useDropzone */ .uI)({
        maxFiles,
        ...props
    });
    // const fileTypeIcon = (type: string) => {
    // 	if (type.includes('image')) {
    // 		return <Icon name="imageIllustration" />
    // 	} else if (type.includes('video')) {
    // 		return <Icon name="videoIllustration" />
    // 	} else if (type.includes('pdf')) {
    // 		return <Icon name="pdfIllustration" />
    // 	}
    // 	return null
    // }
    const locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    //const [thumbnail, setThumbnail] = React.useState<string>()
    const thumbnail = (0,_utils_ThumbnailContext__WEBPACK_IMPORTED_MODULE_4__/* .useThumbnail */ .t0)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().dropzone), isFocused && (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().is_focused), isDragAccept && (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().is_dragAccept), isDragReject && (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().is_dragReject)),
            children: [
                !props.small && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ...getRootProps(),
                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().area),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            ...getInputProps()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().areaContent),
                            children: [
                                iconDecoration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().areaIcon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
                                        name: iconDecoration
                                    })
                                }),
                                areaDescription
                            ]
                        })
                    ]
                }),
                acceptedFiles.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().acceptedFiles),
                    children: acceptedFiles.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().acceptedFile),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().acceptedFilePreview),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: URL.createObjectURL(item),
                                        alt: "uploaded image",
                                        width: 40,
                                        height: 40,
                                        style: {
                                            objectFit: "cover",
                                            borderRadius: "5px"
                                        }
                                    })
                                }),
                                thumbnail.thumbnail !== item.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                    type: "button",
                                    size: 3,
                                    fontSize: "small",
                                    fill: "grey100",
                                    onClick: ()=>{
                                        thumbnail.setThumbnail(item.name);
                                    },
                                    children: "Set as a thumbnail"
                                }),
                                thumbnail.thumbnail == item.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        fontSize: "14px"
                                    },
                                    children: "Thumbnail"
                                })
                            ]
                        }, "".concat(item.name + index)))
                }),
                fileRejections.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().error),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().errorTitle),
                            children: "Errors"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().errorList),
                            children: fileRejections.map((param)=>/*#__PURE__*/ {
                                let { file , errors  } = param;
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        "File name: ",
                                        file.name,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().errorListItems),
                                            children: errors && errors.map((error)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().errorListItem),
                                                    children: error.message
                                                }, error.code))
                                        })
                                    ]
                                }, file.type);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().footer), props.small && (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().footerSmall)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                            type: "button",
                            fill: "grey100",
                            onClick: open,
                            children: locale === "cs" ? "Nahr\xe1t fotku" : "Upload photo"
                        }),
                        footerDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CustomUpload_module_sass__WEBPACK_IMPORTED_MODULE_8___default().footerDescription),
                            children: footerDescription
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6220);
/* harmony import */ var _Flex_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4017);
/* harmony import */ var _Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3__);





function Flex(props) {
    const isMobile = (0,_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("(max-width: 768px)");
    var _props_marginTop;
    const marginTop = (_props_marginTop = props.marginTop) !== null && _props_marginTop !== void 0 ? _props_marginTop : 0;
    var _props_marginBottom;
    const marginBottom = (_props_marginBottom = props.marginBottom) !== null && _props_marginBottom !== void 0 ? _props_marginBottom : 0;
    const perRow = isMobile ? props.mobileItemsPerRow : props.itemsPerRow;
    const itemWidth = perRow ? 100 / perRow : null;
    const space = props.spacing ? props.spacing / 2 : 0;
    var _props_justifyContent, _props_alignItems;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        style: {
            width: "calc(100% + ".concat(space * 2, "px)"),
            marginLeft: "-".concat(space, "px"),
            "--Flex-margin-top": "".concat(marginTop - space, "px"),
            marginBottom: "".concat(marginBottom - space, "px")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().inner),
            style: {
                justifyContent: (_props_justifyContent = props.justifyContent) !== null && _props_justifyContent !== void 0 ? _props_justifyContent : "flex-start",
                alignItems: (_props_alignItems = props.alignItems) !== null && _props_alignItems !== void 0 ? _props_alignItems : "flex-start"
            },
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(props.children), (child)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_Flex_module_sass__WEBPACK_IMPORTED_MODULE_3___default().item)),
                    style: itemWidth ? {
                        width: "calc(".concat(itemWidth, "% - ").concat(space * 2, "px)"),
                        margin: "".concat(space, "px")
                    } : {
                        width: "auto",
                        margin: "0 ".concat(space, "px")
                    },
                    children: child
                }))
        })
    });
}


/***/ }),

/***/ 5021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ TextArea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5640);
/* harmony import */ var _TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4__);





const TextArea = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { name , autoComplete , value , onChange , disabled , readOnly , placeholder , required , iconDecoration , noBorder  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wrapper), iconDecoration && (_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_iconDecoration), noBorder && (_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default().noBorder)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                className: (_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default().input),
                name: name,
                autoComplete: autoComplete,
                readOnly: readOnly,
                placeholder: placeholder,
                value: value,
                onChange: onChange,
                disabled: disabled,
                required: required,
                ref: ref
            }),
            iconDecoration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_TextArea_module_sass__WEBPACK_IMPORTED_MODULE_4___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
                    name: iconDecoration
                })
            })
        ]
    });
});
TextArea.displayName = "TextArea";


/***/ }),

/***/ 195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ filterNonEmpty; }
/* harmony export */ });
function filterNonEmpty(value) {
    return value !== null && value !== undefined;
}


/***/ }),

/***/ 552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Profile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./app/components/Footer.tsx + 1 modules
var Footer = __webpack_require__(7082);
// EXTERNAL MODULE: ./app/components/Nav.tsx + 1 modules
var Nav = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./generated/content.ts
var content = __webpack_require__(1360);
// EXTERNAL MODULE: ./app/hooks/useAuth.ts
var useAuth = __webpack_require__(1108);
// EXTERNAL MODULE: ./app/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(6220);
// EXTERNAL MODULE: ./app/hooks/usePlanteeUser.ts
var usePlanteeUser = __webpack_require__(4481);
// EXTERNAL MODULE: ./app/utils/filterNonEmpty.ts
var filterNonEmpty = __webpack_require__(195);
// EXTERNAL MODULE: ./app/components/AlertPopup.tsx
var AlertPopup = __webpack_require__(2304);
// EXTERNAL MODULE: ./app/components/Box.tsx
var Box = __webpack_require__(8688);
// EXTERNAL MODULE: ./app/components/Buttons.tsx
var Buttons = __webpack_require__(2405);
// EXTERNAL MODULE: ./app/components/CardPlant.tsx + 1 modules
var CardPlant = __webpack_require__(7132);
// EXTERNAL MODULE: ./app/components/Comments.module.sass
var Comments_module = __webpack_require__(2641);
var Comments_module_default = /*#__PURE__*/__webpack_require__.n(Comments_module);
// EXTERNAL MODULE: ./app/components/Flex.tsx
var Flex = __webpack_require__(9129);
;// CONCATENATED MODULE: ./node_modules/@mangoweb/react-fslightbox/dist/index.js


var loadLightbox = function () { return __webpack_require__.e(/* import() */ 771).then(__webpack_require__.bind(__webpack_require__, 2771)).then(function (module) { return module.lightbox; }); };
var useLightbox = function (sources, options) {
    var _a = (0,react.useState)(null), lightbox = _a[0], setLightbox = _a[1];
    (0,react.useEffect)(function () {
        loadLightbox().then(function (lightbox) { return setLightbox(function () { return lightbox; }); });
    }, []);
    return (0,react.useMemo)(function () { return (lightbox ? lightbox(sources, options) : null); }, [sources, lightbox]);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./app/components/Gallery.tsx




function Gallery(props) {
    const options = {};
    const lightbox = useLightbox(props.items.map((item)=>{
        var _item_image, _item_image1, _item_image2;
        return {
            source: String((_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url),
            type: "image",
            caption: ((_item_image1 = item.image) === null || _item_image1 === void 0 ? void 0 : _item_image1.description) ? (_item_image2 = item.image) === null || _item_image2 === void 0 ? void 0 : _item_image2.description : ""
        };
    }), options);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Comments_module_default()).commentImages,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Results photos:"
            }),
            props.items.map((image, i)=>{
                var _image_image, _image_image1, _image_image2, _image_image3, _image_image4;
                var _image_image_alt, _ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>{
                        lightbox === null || lightbox === void 0 ? void 0 : lightbox.open(i);
                    },
                    className: (Comments_module_default()).commentImagesSingle,
                    children: ((_image_image = image.image) === null || _image_image === void 0 ? void 0 : _image_image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (_image_image1 = image.image) === null || _image_image1 === void 0 ? void 0 : _image_image1.url,
                        layout: "fill",
                        objectFit: "cover",
                        alt: (_ref = (_image_image_alt = (_image_image2 = image.image) === null || _image_image2 === void 0 ? void 0 : _image_image2.alt) !== null && _image_image_alt !== void 0 ? _image_image_alt : (_image_image3 = image.image) === null || _image_image3 === void 0 ? void 0 : _image_image3.description) !== null && _ref !== void 0 ? _ref : "",
                        placeholder: "blur",
                        blurDataURL: (_image_image4 = image.image) === null || _image_image4 === void 0 ? void 0 : _image_image4.url
                    })
                }, i);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./app/components/Comments.tsx








function Comments(props) {
    const [toggleAll, setToggleAll] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Comments_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Comments_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    itemsPerRow: 3,
                    spacing: 10,
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    children: props.comments.map((item, index)=>{
                        if (toggleAll || index < 3) {
                            var _item_author, _item_author1, _item_author_avatar, _item_author2, _item_author_avatar1, _item_author3, _item_author_avatar2, _item_author4, _item_author_avatar3, _item_author5, _item_images;
                            var _item_author_avatar_alt, _ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Comments_module_default()).comment,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Comments_module_default()).author,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Comments_module_default()).authorImage,
                                                    children: ((_item_author = item.author) === null || _item_author === void 0 ? void 0 : _item_author.avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: (_item_author1 = item.author) === null || _item_author1 === void 0 ? void 0 : (_item_author_avatar = _item_author1.avatar) === null || _item_author_avatar === void 0 ? void 0 : _item_author_avatar.url,
                                                        layout: "fill",
                                                        objectFit: "cover",
                                                        alt: (_ref = (_item_author_avatar_alt = (_item_author2 = item.author) === null || _item_author2 === void 0 ? void 0 : (_item_author_avatar1 = _item_author2.avatar) === null || _item_author_avatar1 === void 0 ? void 0 : _item_author_avatar1.alt) !== null && _item_author_avatar_alt !== void 0 ? _item_author_avatar_alt : (_item_author3 = item.author) === null || _item_author3 === void 0 ? void 0 : (_item_author_avatar2 = _item_author3.avatar) === null || _item_author_avatar2 === void 0 ? void 0 : _item_author_avatar2.description) !== null && _ref !== void 0 ? _ref : "",
                                                        placeholder: "blur",
                                                        blurDataURL: (_item_author4 = item.author) === null || _item_author4 === void 0 ? void 0 : (_item_author_avatar3 = _item_author4.avatar) === null || _item_author_avatar3 === void 0 ? void 0 : _item_author_avatar3.url
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    children: (_item_author5 = item.author) === null || _item_author5 === void 0 ? void 0 : _item_author5.nick
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.text
                                        }),
                                        ((_item_images = item.images) === null || _item_images === void 0 ? void 0 : _item_images.items) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                                            items: item.images.items
                                        })
                                    ]
                                })
                            }, index);
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                fill: "grey100",
                type: "button",
                onClick: ()=>{
                    setToggleAll((old)=>!old);
                },
                children: toggleAll ? "Show less" : "View all comments (".concat(props.comments.length, ")")
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/Container.tsx
var Container = __webpack_require__(2537);
// EXTERNAL MODULE: ./app/components/CustomUpload.tsx
var CustomUpload = __webpack_require__(5047);
// EXTERNAL MODULE: ./app/components/Icon.tsx + 36 modules
var Icon = __webpack_require__(3);
// EXTERNAL MODULE: ./app/components/Likes.tsx
var Likes = __webpack_require__(4119);
// EXTERNAL MODULE: ./app/components/PlantProfile.module.sass
var PlantProfile_module = __webpack_require__(7724);
var PlantProfile_module_default = /*#__PURE__*/__webpack_require__.n(PlantProfile_module);
// EXTERNAL MODULE: ./app/components/TextArea.tsx
var TextArea = __webpack_require__(5021);
// EXTERNAL MODULE: ./app/components/UserBadge.tsx + 3 modules
var UserBadge = __webpack_require__(8645);
;// CONCATENATED MODULE: ./app/components/PlantProfile.tsx























function ProfileBtns(props) {
    const locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        marginTop: props.isMobile ? 40 : 0,
        spacing: 20,
        justifyContent: props.isMobile ? "flex-start" : "flex-end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                style: {
                    marginBottom: "10px"
                },
                type: "link",
                isBorder: true,
                href: "/create?id=".concat(props.profileId),
                icon: {
                    name: "duplicate",
                    position: "start"
                },
                children: locale === "cs" ? "Duplikovat a upravit" : "Duplicate and edit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                href: "https://plant.ee/products/plantee",
                type: "link",
                target: "_blank",
                fill: "green600",
                icon: {
                    name: "plant",
                    position: "end"
                },
                children: locale === "cs" ? "Pěstovat v Plantee" : "Grow me in Plantee"
            })
        ]
    });
}
function PlantProfile(props) {
    var _props_profile_activeRevision, _props_profile_activeRevision_images, _props_profile_activeRevision1, _props_profile_activeRevision_localesByLocale, _props_profile_activeRevision2, _props_profile_author, _props_profile_author1, _props_profile_author2, _props_profile_activeRevision3, _props_profile_activeRevision_localesByLocale1, _props_profile_activeRevision4, _props_profile_activeRevision_localesByLocale2, _props_profile_activeRevision5, _props_profile_activeRevision_localesByLocale3, _props_profile_activeRevision6, _props_profile_activeRevision7, _props_profile_activeRevision8, _props_profile_activeRevision9, _plantee_auth_addComment_data, _props_profile_author3;
    const isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 768px)");
    const [activeImageIndex, setActiveImageIndex] = react.useState(0);
    const router = (0,next_router.useRouter)();
    const commentInput = react.useRef(null);
    const [commentImage, setCommentImage] = react.useState(undefined);
    const plantee = (0,usePlanteeUser/* usePlanteeUser */.e)();
    const [comments, setComments] = react.useState(props.discussion);
    const [phasesPopupOpen, setPhasesPopupOpen] = react.useState(false);
    const signedIn = (0,useAuth/* useIsSignedIn */.AN)();
    const locale = router.locale;
    const images = (_props_profile_activeRevision = props.profile.activeRevision) === null || _props_profile_activeRevision === void 0 ? void 0 : (_props_profile_activeRevision_images = _props_profile_activeRevision.images) === null || _props_profile_activeRevision_images === void 0 ? void 0 : _props_profile_activeRevision_images.items.sort((a, b)=>{
        var _b_image, _a_image;
        return Number((_b_image = b.image) === null || _b_image === void 0 ? void 0 : _b_image.isThumbnail) - Number((_a_image = a.image) === null || _a_image === void 0 ? void 0 : _a_image.isThumbnail);
    });
    var _props_profile_author_nick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((PlantProfile_module_default()).wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (PlantProfile_module_default()).close,
                onClick: ()=>{
                    router.back();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "close"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PlantProfile_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    view: "wide",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PlantProfile_module_default()).head,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (PlantProfile_module_default()).left,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                (_props_profile_activeRevision1 = props.profile.activeRevision) === null || _props_profile_activeRevision1 === void 0 ? void 0 : (_props_profile_activeRevision_localesByLocale = _props_profile_activeRevision1.localesByLocale) === null || _props_profile_activeRevision_localesByLocale === void 0 ? void 0 : _props_profile_activeRevision_localesByLocale.name,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (_props_profile_activeRevision2 = props.profile.activeRevision) === null || _props_profile_activeRevision2 === void 0 ? void 0 : _props_profile_activeRevision2.latinName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (PlantProfile_module_default()).gallery,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PlantProfile_module_default()).galleryMain,
                                                    children: images === null || images === void 0 ? void 0 : images.map((item, index)=>{
                                                        if (item.image) {
                                                            var _item_image, _item_image1;
                                                            var _item_image_alt, _ref;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,clsx_m/* default */.Z)((PlantProfile_module_default()).galleryMainImage, index === activeImageIndex && (PlantProfile_module_default()).active),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url,
                                                                    layout: "fill",
                                                                    objectFit: "cover",
                                                                    alt: (_ref = (_item_image_alt = item.image.alt) !== null && _item_image_alt !== void 0 ? _item_image_alt : item.image.description) !== null && _ref !== void 0 ? _ref : "",
                                                                    placeholder: "blur",
                                                                    blurDataURL: item.image.url
                                                                }, String((_item_image1 = item.image) === null || _item_image1 === void 0 ? void 0 : _item_image1.id))
                                                            }, index);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PlantProfile_module_default()).gallerySide,
                                                    children: images === null || images === void 0 ? void 0 : images.map((item, index)=>{
                                                        if (item.image) {
                                                            var _item_image, _item_image1;
                                                            var _item_image_alt, _ref;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: (PlantProfile_module_default()).gallerySideImage,
                                                                onClick: ()=>{
                                                                    setActiveImageIndex(index);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url,
                                                                    layout: "fill",
                                                                    objectFit: "cover",
                                                                    alt: (_ref = (_item_image_alt = item.image.alt) !== null && _item_image_alt !== void 0 ? _item_image_alt : item.image.description) !== null && _ref !== void 0 ? _ref : "",
                                                                    placeholder: "blur",
                                                                    blurDataURL: item.image.url
                                                                }, String((_item_image1 = item.image) === null || _item_image1 === void 0 ? void 0 : _item_image1.id))
                                                            }, index);
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (PlantProfile_module_default()).right,
                                    children: [
                                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBtns, {
                                            profileId: props.profile.id
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            marginTop: 55,
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (PlantProfile_module_default()).author,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "By"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBadge/* UserBadge */.s, {
                                                            name: (_props_profile_author_nick = (_props_profile_author = props.profile.author) === null || _props_profile_author === void 0 ? void 0 : _props_profile_author.nick) !== null && _props_profile_author_nick !== void 0 ? _props_profile_author_nick : "",
                                                            image: (_props_profile_author1 = props.profile.author) === null || _props_profile_author1 === void 0 ? void 0 : _props_profile_author1.avatar,
                                                            isHighlighted: true,
                                                            link: {
                                                                internalLink: {
                                                                    url: "/author/".concat((_props_profile_author2 = props.profile.author) === null || _props_profile_author2 === void 0 ? void 0 : _props_profile_author2.id)
                                                                },
                                                                type: content/* LinkType.internal */.Un.internal
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PlantProfile_module_default()).likes,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Likes/* Likes */.d, {
                                                        count: props.profile.likedByUser.length,
                                                        plantProfile: props.profile
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                            className: (PlantProfile_module_default()).description,
                                            children: (_props_profile_activeRevision3 = props.profile.activeRevision) === null || _props_profile_activeRevision3 === void 0 ? void 0 : (_props_profile_activeRevision_localesByLocale1 = _props_profile_activeRevision3.localesByLocale) === null || _props_profile_activeRevision_localesByLocale1 === void 0 ? void 0 : _props_profile_activeRevision_localesByLocale1.description
                                        }),
                                        ((_props_profile_activeRevision4 = props.profile.activeRevision) === null || _props_profile_activeRevision4 === void 0 ? void 0 : (_props_profile_activeRevision_localesByLocale2 = _props_profile_activeRevision4.localesByLocale) === null || _props_profile_activeRevision_localesByLocale2 === void 0 ? void 0 : _props_profile_activeRevision_localesByLocale2.growingConditions) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: (PlantProfile_module_default()).description,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Growing conditions"
                                                }),
                                                (_props_profile_activeRevision5 = props.profile.activeRevision) === null || _props_profile_activeRevision5 === void 0 ? void 0 : (_props_profile_activeRevision_localesByLocale3 = _props_profile_activeRevision5.localesByLocale) === null || _props_profile_activeRevision_localesByLocale3 === void 0 ? void 0 : _props_profile_activeRevision_localesByLocale3.growingConditions
                                            ]
                                        }),
                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBtns, {
                                            profileId: props.profile.id,
                                            isMobile: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PlantProfile_module_default()).phases,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        locale === "cs" ? "F\xe1ze růstu" : "Growing phases",
                                        " (",
                                        (_props_profile_activeRevision6 = props.profile.activeRevision) === null || _props_profile_activeRevision6 === void 0 ? void 0 : _props_profile_activeRevision6.phases.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    marginTop: 50,
                                    marginBottom: 50,
                                    spacing: 50,
                                    justifyContent: "flex-start",
                                    children: (_props_profile_activeRevision7 = props.profile.activeRevision) === null || _props_profile_activeRevision7 === void 0 ? void 0 : _props_profile_activeRevision7.phases.map((item, index)=>{
                                        var _item_phaseType, _item_phaseType1, _item_phaseType_icon, _item_phaseType2, _item_phaseType3, _item_phaseType4, _item_phaseType5, _item_phaseType_icon1, _item_phaseType6, _item_phaseType_localesByLocale;
                                        var _item_phaseType_icon_alt, _ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (PlantProfile_module_default()).phase,
                                            children: [
                                                ((_item_phaseType = item.phaseType) === null || _item_phaseType === void 0 ? void 0 : _item_phaseType.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PlantProfile_module_default()).phaseImage,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: (_item_phaseType1 = item.phaseType) === null || _item_phaseType1 === void 0 ? void 0 : (_item_phaseType_icon = _item_phaseType1.icon) === null || _item_phaseType_icon === void 0 ? void 0 : _item_phaseType_icon.url,
                                                        layout: "responsive",
                                                        objectFit: "cover",
                                                        width: item.phaseType.icon.width,
                                                        height: item.phaseType.icon.height,
                                                        alt: (_ref = (_item_phaseType_icon_alt = (_item_phaseType2 = item.phaseType) === null || _item_phaseType2 === void 0 ? void 0 : _item_phaseType2.icon.alt) !== null && _item_phaseType_icon_alt !== void 0 ? _item_phaseType_icon_alt : (_item_phaseType3 = item.phaseType) === null || _item_phaseType3 === void 0 ? void 0 : _item_phaseType3.icon.description) !== null && _ref !== void 0 ? _ref : "",
                                                        placeholder: "blur",
                                                        blurDataURL: (_item_phaseType4 = item.phaseType) === null || _item_phaseType4 === void 0 ? void 0 : _item_phaseType4.icon.url
                                                    }, String((_item_phaseType5 = item.phaseType) === null || _item_phaseType5 === void 0 ? void 0 : (_item_phaseType_icon1 = _item_phaseType5.icon) === null || _item_phaseType_icon1 === void 0 ? void 0 : _item_phaseType_icon1.id))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: (_item_phaseType6 = item.phaseType) === null || _item_phaseType6 === void 0 ? void 0 : (_item_phaseType_localesByLocale = _item_phaseType6.localesByLocale) === null || _item_phaseType_localesByLocale === void 0 ? void 0 : _item_phaseType_localesByLocale.name
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    type: "button",
                                    fill: "grey100",
                                    onClick: ()=>{
                                        setPhasesPopupOpen(true);
                                    },
                                    children: locale === "cs" ? "V\xedce o f\xe1z\xedch" : "More about phases"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertPopup/* AlertPopup */.h, {
                                    isOpen: phasesPopupOpen,
                                    onClickClose: ()=>{
                                        setPhasesPopupOpen(false);
                                    },
                                    type: "default",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PlantProfile_module_default()).phasesPopup,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    locale === "cs" ? "F\xe1ze růstu" : "Growing phases",
                                                    " (",
                                                    (_props_profile_activeRevision8 = props.profile.activeRevision) === null || _props_profile_activeRevision8 === void 0 ? void 0 : _props_profile_activeRevision8.phases.length,
                                                    ")"
                                                ]
                                            }),
                                            (_props_profile_activeRevision9 = props.profile.activeRevision) === null || _props_profile_activeRevision9 === void 0 ? void 0 : _props_profile_activeRevision9.phases.map((phase, index)=>{
                                                var _phase_phaseType, _phase_phaseType1, _phase_phaseType_icon, _phase_phaseType2, _phase_phaseType3, _phase_phaseType4, _phase_phaseType5, _phase_phaseType_icon1, _phase_phaseType6, _phase_phaseType_localesByLocale, _phase_monday, _phase_monday1, _phase_monday2, _phase_monday3, _phase_monday4, _phase_monday5;
                                                var _phase_phaseType_icon_alt, _ref;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                            justifyContent: "space-between",
                                                            marginBottom: 20,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                    children: [
                                                                        ((_phase_phaseType = phase.phaseType) === null || _phase_phaseType === void 0 ? void 0 : _phase_phaseType.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (PlantProfile_module_default()).phasesPopupIcon,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: (_phase_phaseType1 = phase.phaseType) === null || _phase_phaseType1 === void 0 ? void 0 : (_phase_phaseType_icon = _phase_phaseType1.icon) === null || _phase_phaseType_icon === void 0 ? void 0 : _phase_phaseType_icon.url,
                                                                                layout: "responsive",
                                                                                objectFit: "cover",
                                                                                width: phase.phaseType.icon.width,
                                                                                height: phase.phaseType.icon.height,
                                                                                alt: (_ref = (_phase_phaseType_icon_alt = (_phase_phaseType2 = phase.phaseType) === null || _phase_phaseType2 === void 0 ? void 0 : _phase_phaseType2.icon.alt) !== null && _phase_phaseType_icon_alt !== void 0 ? _phase_phaseType_icon_alt : (_phase_phaseType3 = phase.phaseType) === null || _phase_phaseType3 === void 0 ? void 0 : _phase_phaseType3.icon.description) !== null && _ref !== void 0 ? _ref : "",
                                                                                placeholder: "blur",
                                                                                blurDataURL: (_phase_phaseType4 = phase.phaseType) === null || _phase_phaseType4 === void 0 ? void 0 : _phase_phaseType4.icon.url
                                                                            }, String((_phase_phaseType5 = phase.phaseType) === null || _phase_phaseType5 === void 0 ? void 0 : (_phase_phaseType_icon1 = _phase_phaseType5.icon) === null || _phase_phaseType_icon1 === void 0 ? void 0 : _phase_phaseType_icon1.id))
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            children: "".concat(index + 1, ". ").concat((_phase_phaseType6 = phase.phaseType) === null || _phase_phaseType6 === void 0 ? void 0 : (_phase_phaseType_localesByLocale = _phase_phaseType6.localesByLocale) === null || _phase_phaseType_localesByLocale === void 0 ? void 0 : _phase_phaseType_localesByLocale.name)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        phase.daysUntilNextPhase,
                                                                        " days"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: (PlantProfile_module_default()).phasesPopupList,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            name: "sun"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                    children: locale === "cs" ? "Světlo" : "Lighting"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        (_phase_monday = phase.monday) === null || _phase_monday === void 0 ? void 0 : _phase_monday.ppfd,
                                                                                        "/m2/s, ",
                                                                                        (_phase_monday1 = phase.monday) === null || _phase_monday1 === void 0 ? void 0 : _phase_monday1.dli,
                                                                                        "/mol/m2d"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            name: "temperature"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                    children: locale === "cs" ? "Teplota půdy" : "Soil temperature"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        (_phase_monday2 = phase.monday) === null || _phase_monday2 === void 0 ? void 0 : _phase_monday2.daySoilTemperature,
                                                                                        "\xb0C"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            name: "mositure"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                    children: locale === "cs" ? "Vlhost půdy" : "Soil moisture"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        (_phase_monday3 = phase.monday) === null || _phase_monday3 === void 0 ? void 0 : _phase_monday3.startWatering,
                                                                                        "%"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            name: "planttemprature"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                    children: locale === "cs" ? "Teplota rostliny" : "Plant temperature"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        (_phase_monday4 = phase.monday) === null || _phase_monday4 === void 0 ? void 0 : _phase_monday4.dayPlantTemperature,
                                                                                        "\xb0C"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            name: "airhumidity"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                    children: locale === "cs" ? "Vlhkost vzduchu" : "Air humidity"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        (_phase_monday5 = phase.monday) === null || _phase_monday5 === void 0 ? void 0 : _phase_monday5.dayPlantTemperature,
                                                                                        "%"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PlantProfile_module_default()).discussion,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: locale === "cs" ? "Koment\xe1ře" : "Comments"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, {
                                    comments: comments
                                }),
                                signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: (PlantProfile_module_default()).commentForm,
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        console.log("comment submit");
                                        const textarea = commentInput.current ? commentInput.current : null;
                                        const comment = textarea ? textarea.value : null;
                                        if (comment) {
                                            plantee.auth.addComment.mutateAsync({
                                                text: comment,
                                                plantProfileId: String(props.profile.id),
                                                image: commentImage,
                                                mimeType: commentImage ? commentImage.type : undefined
                                            }).then((v)=>{
                                                if (v.mutation.createDiscussionPost.ok && textarea) {
                                                    textarea.value = "";
                                                }
                                                if (v.comments.listDiscussionPost) {
                                                    setComments(v.comments.listDiscussionPost);
                                                }
                                            });
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: locale === "cs" ? "Přidej koment\xe1ř" : "Add your own comment"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* TextArea */.K, {
                                                    ref: commentInput,
                                                    required: true,
                                                    name: "comment",
                                                    noBorder: true,
                                                    placeholder: locale === "cs" ? "Pěstovali jste tuto rostlinu? Dej tvůrci zpětnou vazbu a ukaž ostatn\xedm tvoje v\xfdsledky." : "Did you tried this plant profile? Give the creator your feedback and others people your results. It helps the community grows!"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (PlantProfile_module_default()).commentFormBtns,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomUpload/* CustomUpload */.L, {
                                                            accept: {
                                                                "image/*": []
                                                            },
                                                            small: true,
                                                            maxSize: 10000000,
                                                            iconDecoration: "imageIllustration",
                                                            areaDescription: "Drop your image here",
                                                            footerDescription: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: "Supported files: jpg, png. Max 10 MB."
                                                            }),
                                                            onDropAccepted: async (param)=>{
                                                                let [file] = param;
                                                                console.log(file);
                                                                if (file) {
                                                                    setCommentImage(file);
                                                                }
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (PlantProfile_module_default()).commentSubmit,
                                                            children: ((_plantee_auth_addComment_data = plantee.auth.addComment.data) === null || _plantee_auth_addComment_data === void 0 ? void 0 : _plantee_auth_addComment_data.mutation.createDiscussionPost.ok) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: locale === "cs" ? "Koment\xe1ř \xfaspěšně přid\xe1n" : "Comment added sucessfully"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                                                type: "submit",
                                                                fill: "groundBlack",
                                                                children: locale === "cs" ? "Zveřejnit koment\xe1ř" : "Submit comment"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    type: "link",
                                    fill: "green600",
                                    href: "/user/edit",
                                    children: locale === "cs" ? "Přihl\xe1sit se pro přid\xe1n\xed koment\xe1ře" : "Log in to comment"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PlantProfile_module_default()).otherProfiles,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: locale === "cs" ? "V\xedce pěstebn\xedch profilů od uživatele" : "More profiles from user"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    spacing: isMobile ? 10 : 40,
                                    itemsPerRow: 5,
                                    mobileItemsPerRow: 2,
                                    marginTop: 30,
                                    marginBottom: 30,
                                    children: props.authorProfiles.map((item, index)=>{
                                        if (item.id !== props.profile.id) {
                                            var _item_activeRevision, _item_activeRevision_images, _item_activeRevision1, _item_activeRevision_localesByLocale, _item_author, _item_author1, _item_author2, _item_author3, _item_author4;
                                            var _item_activeRevision_images_items_map_filter, _item_activeRevision_localesByLocale_name, _ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPlant/* CardPlant */.e, {
                                                images: (_item_activeRevision_images_items_map_filter = (_item_activeRevision = item.activeRevision) === null || _item_activeRevision === void 0 ? void 0 : (_item_activeRevision_images = _item_activeRevision.images) === null || _item_activeRevision_images === void 0 ? void 0 : _item_activeRevision_images.items.map((item)=>item.image).filter(filterNonEmpty/* filterNonEmpty */.y)) !== null && _item_activeRevision_images_items_map_filter !== void 0 ? _item_activeRevision_images_items_map_filter : [],
                                                title: (_item_activeRevision_localesByLocale_name = (_item_activeRevision1 = item.activeRevision) === null || _item_activeRevision1 === void 0 ? void 0 : (_item_activeRevision_localesByLocale = _item_activeRevision1.localesByLocale) === null || _item_activeRevision_localesByLocale === void 0 ? void 0 : _item_activeRevision_localesByLocale.name) !== null && _item_activeRevision_localesByLocale_name !== void 0 ? _item_activeRevision_localesByLocale_name : "",
                                                user: {
                                                    name: (_ref = ((_item_author = item.author) === null || _item_author === void 0 ? void 0 : _item_author.nick) || ((_item_author1 = item.author) === null || _item_author1 === void 0 ? void 0 : _item_author1.email)) !== null && _ref !== void 0 ? _ref : "",
                                                    image: (_item_author2 = item.author) === null || _item_author2 === void 0 ? void 0 : _item_author2.avatar,
                                                    id: String((_item_author3 = item.author) === null || _item_author3 === void 0 ? void 0 : _item_author3.id)
                                                },
                                                likes: 0,
                                                link: "/profile/".concat((_item_author4 = item.author) === null || _item_author4 === void 0 ? void 0 : _item_author4.id, "/").concat(item.id),
                                                plantProfile: item
                                            }, index);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                                    type: "link",
                                    href: "/author/".concat((_props_profile_author3 = props.profile.author) === null || _props_profile_author3 === void 0 ? void 0 : _props_profile_author3.id),
                                    fill: "grey100",
                                    children: locale === "cs" ? "Zobrazit vše" : "View all"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./app/components/PageInfo.tsx
var PageInfo = __webpack_require__(5358);
;// CONCATENATED MODULE: ./pages/profile/[author]/[profile].tsx





var __N_SSP = true;
function Profile(props) {
    var _plantProfile_activeRevision, _plantProfile_activeRevision_localesByLocale;
    const plantProfile = props.data.getPlantProfile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageInfo/* PageInfo */.S, {
                title: plantProfile === null || plantProfile === void 0 ? void 0 : (_plantProfile_activeRevision = plantProfile.activeRevision) === null || _plantProfile_activeRevision === void 0 ? void 0 : (_plantProfile_activeRevision_localesByLocale = _plantProfile_activeRevision.localesByLocale) === null || _plantProfile_activeRevision_localesByLocale === void 0 ? void 0 : _plantProfile_activeRevision_localesByLocale.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* Nav */.J, {}),
            plantProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlantProfile, {
                profile: plantProfile,
                authorProfiles: props.data.listPlantProfile,
                discussion: props.data.listDiscussionPost
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
}


/***/ }),

/***/ 4626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlertPopup_wrapper__JLEpv","isOpen":"AlertPopup_isOpen__mEI4i","is_success":"AlertPopup_is_success__V3u6K","is_error":"AlertPopup_is_error__emDJT","content":"AlertPopup_content__kOhIr","close":"AlertPopup_close__laSXd"};

/***/ }),

/***/ 8774:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Box_wrapper__QJFOq","view-relative":"Box_view-relative__gfh9_","view-largePadding":"Box_view-largePadding__viwDh"};

/***/ }),

/***/ 2641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Comments_wrapper__kpoZ5","author":"Comments_author__YBryy","authorImage":"Comments_authorImage__EGbsM","commentImagesSingle":"Comments_commentImagesSingle__oP68K","inner":"Comments_inner__2Pi6B","comment":"Comments_comment__yRLJk","commentImages":"Comments_commentImages__MASji"};

/***/ }),

/***/ 706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"CustomUpload_dropzone__9Lor_","is_dragAccept":"CustomUpload_is_dragAccept__qMRuc","is_dragReject":"CustomUpload_is_dragReject__8QMcy","is_focused":"CustomUpload_is_focused__FYnbM","area":"CustomUpload_area__0UIxb","areaIcon":"CustomUpload_areaIcon__PnRST","areaContent":"CustomUpload_areaContent__c4ytF","acceptedFiles":"CustomUpload_acceptedFiles__JqMSh","acceptedFile":"CustomUpload_acceptedFile__ArtMY","acceptedFileName":"CustomUpload_acceptedFileName__MrhhG","acceptedFileIcon":"CustomUpload_acceptedFileIcon__TutHM","footer":"CustomUpload_footer__Ov2Lx","footerDescription":"CustomUpload_footerDescription__rKUqY","error":"CustomUpload_error__tPvsX","errorTitle":"CustomUpload_errorTitle__f8MCR","footerSmall":"CustomUpload_footerSmall__Mdv4l"};

/***/ }),

/***/ 4017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Flex_wrapper__1kICk","inner":"Flex_inner__z2K8_","item":"Flex_item__7CXlR"};

/***/ }),

/***/ 7724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlantProfile_wrapper__OoYDP","inner":"PlantProfile_inner__V3DLz","gallery":"PlantProfile_gallery__x8xL7","galleryMain":"PlantProfile_galleryMain__2RCYl","galleryMainImage":"PlantProfile_galleryMainImage__RHQ0_","active":"PlantProfile_active__H2WL0","gallerySide":"PlantProfile_gallerySide__t06KC","gallerySideImage":"PlantProfile_gallerySideImage__eyI8b","head":"PlantProfile_head__xOzT6","left":"PlantProfile_left__2HeDc","right":"PlantProfile_right__shlQI","author":"PlantProfile_author__AEOPw","description":"PlantProfile_description__1CjtE","phases":"PlantProfile_phases__ya22I","phase":"PlantProfile_phase__aWQ_m","phaseImage":"PlantProfile_phaseImage___X6Ds","otherProfiles":"PlantProfile_otherProfiles__hhieL","close":"PlantProfile_close__mJErl","commentSubmit":"PlantProfile_commentSubmit__agBPm","discussion":"PlantProfile_discussion__quNRJ","commentForm":"PlantProfile_commentForm__z391Q","commentFormBtns":"PlantProfile_commentFormBtns__WKByV","phasesPopup":"PlantProfile_phasesPopup__Qnd3c","phasesPopupIcon":"PlantProfile_phasesPopupIcon__RudcE","phasesPopupList":"PlantProfile_phasesPopupList__QzYWd"};

/***/ }),

/***/ 5640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__ncbeB","is_iconDecoration":"TextArea_is_iconDecoration__q3naY","input":"TextArea_input__kYBYs","noBorder":"TextArea_noBorder__Ws5HP","icon":"TextArea_icon__RqwCO"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [407,755,32,424,288,3,251,941,132,774,888,179], function() { return __webpack_exec__(1276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);